import { useQuery } from '@tanstack/react-query'

import { ReactQueryHttpError, VqaMetadataKeyValues } from '@sparkai/shared-types'

import { apiClient } from '../../apiClient'

const QUERY_PREFIX = 'vqa-metadata-values'

function useGetUniqueAutonomousSystemIds(programId: string, metadataKey: string) {
  return useQuery<VqaMetadataKeyValues['values'], ReactQueryHttpError>({
    queryKey: [QUERY_PREFIX, programId, metadataKey],
    queryFn: async () => {
      const { data } = await apiClient.get(`/int/v3/programs/${programId}/insights/vqa/metadata`, {
        params: {
          metadataKey,
        },
      })
      return data.values
    },
    enabled: Boolean(programId),
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export { useGetUniqueAutonomousSystemIds }
